import { render, staticRenderFns } from "./CloseOrder.vue?vue&type=template&id=222f65fe&scoped=true"
import script from "./CloseOrder.vue?vue&type=script&lang=js"
export * from "./CloseOrder.vue?vue&type=script&lang=js"
import style0 from "./CloseOrder.vue?vue&type=style&index=0&id=222f65fe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222f65fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('222f65fe')) {
      api.createRecord('222f65fe', component.options)
    } else {
      api.reload('222f65fe', component.options)
    }
    module.hot.accept("./CloseOrder.vue?vue&type=template&id=222f65fe&scoped=true", function () {
      api.rerender('222f65fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/components/CloseOrder.vue"
export default component.exports